<template>
  <div
    class="flex flex-col items-center mx-4 mt-3 px-2"
    id="a4-receipt"
    :class="{
      'dir-ltr': $ctx.receiptLanguage == 'en',
      'dir-rtl': $ctx.receiptLanguage == 'ar'
    }"
  >
    <div class="flex flex-col items-center w-full a4-receipt-page" style="height: 100vh;">
      <!-- header info -->
      <div id="a4-receipt-header" class="flex flex-col w-full">
        <div class="flex mt-4 justify-between items-center w-full">
          <div class="mx-8 mt-3 pb-2">
            <div class="flex items-center gap-2 mb-1">
              <img src="@/assets/icons/receipt/map-marker.svg" width="16" height="16" class="shrink-0" />
              <span>{{ settingsStore.getValue('company_address') }}</span>
            </div>
            <div class="flex items-center gap-2 mb-1">
              <img src="@/assets/icons/receipt/phone.svg" width="16" height="16" class="shrink-0" />
              <span dir="ltr">{{ settingsStore.getValue('company_phone1') + (settingsStore.getValue('company_phone2')? ` - ${settingsStore.getValue('company_phone2')}`: '') }}</span>
            </div>
            <div class="flex items-center gap-6">
              <div v-if="settingsStore.getValue('company_email')" class="flex items-center gap-2">
                <img src="@/assets/icons/receipt/email.svg" width="16" height="16" class="shrink-0" />
                <span>{{ settingsStore.getValue('company_email') }}</span>
              </div>
              <div v-if="settingsStore.getValue('company_website')" class="flex items-center gap-2">
                <img src="@/assets/icons/receipt/web.svg" width="16" height="16" class="shrink-0" />
                <span>{{ settingsStore.getValue('company_website') }}</span>
              </div>
            </div>
          </div>

          <div class="mx-8">
            <img :src="settingsStore.getValue('receipt_logo') ? settingsStore.storagePath + '/' + settingsStore.getValue('receipt_logo'): '/images/logo.svg'" :width="settingsStore.getValue('receipt_logo_width')" :style="{'margin-top': settingsStore.getValue('receipt_logo_top_margin') + 'px', 'margin-right': settingsStore.getValue('receipt_logo_right_margin') + 'px'}" alt="" />
          </div>
        </div>

        <div class="flex flex-col w-full items-center">
          <div class="w-11/12 h-[3px] rounded-full"
              :style="{background: `linear-gradient(to right, transparent, ${settingsStore.getValue('receipt_branding_color') || '#585954'}, transparent)`}"></div>
        </div>
      </div>

      <div id="a4-receipt-body" class="w-full">
        <!-- title -->
        <div class="flex flex-col w-full mt-2 items-center">
          <h2 class="bg-gray-200 rounded py-1 px-16 font-bold mt-3 capitalize">
            {{ receiptTranslate("Purchase Order", "receipt.purchaseOrder") }}
          </h2>
        </div>

        <!-- order type info and barcode -->
        <div class="flex w-full justify-between px-8">
          <div>
            <table class="w-full text-sm">
<!--              <tr>-->
<!--                <td>-->
<!--                  <p>-->
<!--                    {{ receiptTranslate("Purchase Order No", "purchaseOrderNo") }}-->
<!--                  </p>-->
<!--                </td>-->
<!--                <td>-->
<!--                  <p class="font-bold mx-5">{{ order.externalID }}</p>-->
<!--                </td>-->
<!--              </tr>-->
              <tr>
                <td>
                  <p>
                    {{ receiptTranslate("Vendor", "receipt.vendor") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{
                      order.vendor?.name
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="order.customer">
                <td>
                  <p>
                    {{ receiptTranslate("Customer", "receipt.customer") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{
                      order.customer.name
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="order.manualNumber">
                <td>
                  <p>
                    {{ receiptTranslate("Manual No", "receipt.manualNumber") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{
                      order.manualNumber
                    }}
                  </p>
                </td>
              </tr>
<!--              <tr>-->
<!--                <td>-->
<!--                  <p>-->
<!--                    {{ receiptTranslate("Location", "receipt.location") }}-->
<!--                  </p>-->
<!--                </td>-->
<!--                <td>-->
<!--                  <p v-if="$ctx.receiptLanguage == 'en'" class="font-bold mx-5">-->
<!--                    {{ order.location?.enName || "" }}-->
<!--                  </p>-->
<!--                  <p v-if="$ctx.receiptLanguage == 'ar'" class="font-bold mx-5">-->
<!--                    {{ order.location?.arName || "" }}-->
<!--                  </p>-->
<!--                </td>-->
<!--              </tr>-->
              <tr v-if="order.referenceableExternalID">
                <td>
                  <p>
                    {{ receiptTranslate("Order No", "receipt.orderNo") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">{{ order.referenceableExternalID }}</p>
                </td>
              </tr>
              <tr v-if="settingsStore.getValue('hide_cashier_name_in_receipt') != 'true'">
                <td>
                  <p>
                    {{ receiptTranslate("Cashier", "receipt.cashier") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">{{ order.user?.fullName }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    {{ receiptTranslate("Date & Time", "receipt.dateAndTime") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5" dir="ltr">
                    {{ parseFormat(order.createdAt) }}
                  </p>
                </td>
              </tr>
              <tr v-if="order.notes">
                <td>
                  <p>
                    {{ receiptTranslate("Order Notes", "receipt.orderNotes") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5" dir="ltr">
                    {{ order.notes }}
                  </p>
                </td>
              </tr>
            </table>
          </div>

          <div class="flex flex-col items-center">
            <div>
              <svg id="barcode" class="mt-3"></svg>
              <div class="flex items-center justify-center">
                <span class="font-bold mx-5" style="font-size: calc(20px * var(--receipt-font-scale, 1));">{{
                  barcodeText
                }}</span>
              </div>
            </div>
            <div
                v-if="order?.pouchID"
                class="flex flex-col w-full items-center"
            >
              <h2 class="bg-gray-200 rounded py-1 px-2 flex">
                <span>{{ receiptTranslate("Pouch #", "receipt.pouch") }}</span>
                <span class="flex justify-end custom-bold mx-2">
                  {{ order?.pouchID }}
                </span>
              </h2>
            </div>
          </div>
        </div>

        <!-- items -->
        <div class="w-full px-8 my-2 text-sm">
          <table class="receipt-table w-full">
            <thead>
              <tr class="text-sm">
                <th>
                  {{ receiptTranslate("Item Name", "receipt.itemName") }}
                </th>
                <th style="width: 80px">{{ receiptTranslate("Qty", "receipt.qty") }}</th>
              </tr>
            </thead>

            <tbody v-if="order.orderItems">
              <tr
                v-for="(oi, i) in order.orderItems"
                :key="i"
                class="text-sm"
                :class="{ 'receipt-row-border': !oi.item.isSerialized }"
              >
                <td class="text-sm reciept-cell">
                  <div>
                    <span>{{ oi.item.name }}</span>
                    <span v-if="oi.packInfo?.packID" class="mx-1">{{ ` - ${getPackName(oi)}, ${oi.packInfo.packQuantity} ${t('pcs')}` }}</span>
                  </div>
                  <div v-if="oi.item.isSerialized" class="flex gap-2 flex-wrap">
                    <small v-for="ois in oi.orderItemSerials" class="bg-gray-200 rounded-md px-1">{{ ois.itemSerial?.number }}</small>
                  </div>
                  <small>{{ oi.notes }}</small>
                </td>

                <td>{{ oi.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        id="a4-receipt-footer"
        v-if="settingsStore.getValue('show_receipts_thecky_footer') == 'true'"
        class="flex justify-center self-center w-full mt-auto"
      >
        <div
          class="flex items-center justify-between py-4 px-4 mt-2"
          style="bottom: 0px; width: 95%; border-top: 2px solid #BDC7D6"
        >
          <p><img src="@/assets/images/thecky-qr.png" style="height: 25px;"/></p>
          <p><img src="@/assets/images/footer.svg" style="height: 25px;"/></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import {i18nOrderMessages} from "@/models/sales/Order";
import {PurchaseOrder as Order,  PurchaseOrderItem as OrderItem} from "@/models/inventory/PurchaseOrder";

import { parseFormat } from "@/utils/date";
import { useI18n } from "vue-i18n";
import { Transaction } from "@/models/accounting/Transaction";
import JsBarcode from "jsbarcode";
import {useSettingsStore} from "@/stores/settingsStore";
import { receiptPrintCSS } from "@/utils/receiptPrint";

export default defineComponent({
  components: {},

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          ...i18nOrderMessages.en
        },
        ar: {
          ...i18nOrderMessages.ar,
          purchaseOrderNo: 'رقم طلب الشراء',
          receipt: {
            vendor: 'المورّد',
            purchaseOrder: "طلب شراء",
            type: "نوع الطلب",
            location: "المتجر",
            orderNo: "رقم الطلب",
            cashier: "موظف الكاشير",
            dateAndTime: "التاريخ والوقت",
            orderNotes: "ملاحظات الطلب",
            itemName: "اسم المنتج",
            qty: "الكمية",
            manualNumber: 'الرقم الخاص',
            customer: 'الزبون',
            pouch: "رقم المحفظة",
          }
        }
      }
    });

    const settingsStore = useSettingsStore();

    return { t, settingsStore };
  },
  props: {
    order: {
      type: Order,
      required: true
    },
    transactions: {
      type: Array as PropType<Array<Transaction>>,
      required: true
    },
    barcodeText: {
      type: String,
      required: true
    }
  },
  mounted() {
    setTimeout(() => {
      JsBarcode("#barcode", String(this.order.externalID!.slice()), {
        height: 50,
        displayValue: false
      });
    }, 100);
  },
  created() {
    // Add print CSS when component is created
    this.addPrintCSS();
  },
  beforeUnmount() {
    // Remove print CSS when component is about to be destroyed
    this.removePrintCSS();
  },
  methods: {
    parseFormat,
    print() {
      window.print();
    },
    addPrintCSS() {
      // Create a style element with a unique id
      const style = document.createElement("style");
      style.setAttribute("id", "print-css");
      style.textContent = receiptPrintCSS(this.$ctx.getReceiptSize());
      // Append the style to the document head
      document.head.appendChild(style);
    },
    removePrintCSS() {
      // Find and remove the style element
      const style = document.querySelector("#print-css");
      if (style && style.parentNode) {
        style.parentNode.removeChild(style);
      }
    },
    receiptTranslate(value: string, translateKey: string): string {
      return this.$ctx.receiptLanguage == "en"
        ? value
        : this.t(translateKey, this.$ctx.receiptLanguage);
    },
    getPackName(oi: OrderItem) {
      for (const ip of oi.item.itemPacks) {
        if (ip.id == oi.packInfo.itemPackID) {
          return this.$ctx.locale == 'en' ? ip.pack?.enName: ip.pack?.arName
        }
      }
    },
    orderHasPack(order: Order) {
      let has = false;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          has = true;
          break
        }
      }
      return has;
    },
  }
});
</script>
<style>
.thecky-site {
  color: #000;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 3px;
}

#a4-receipt {
  width: 210mm;
  overflow: scroll;
  background-color: #fff;
}

@media print {
  body * {
    page-break-after: avoid;
    visibility: hidden;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #a4-receipt,
  #a4-receipt * {
    visibility: visible;
  }

  #a4-receipt {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
    margin: 0cm;
  }

  #a4-receipt-header {
    top: 0;
  }

  #a4-receipt-body {
    position: relative;
  }

  p,
  div {
    page-break-inside: avoid;
  }
}
</style>
